import React from 'react';
import { ArrowRight as ArrowRightIcon } from '@phosphor-icons/react';
import { Section, SectionTitle, Lead } from '../Section';
import { clinicians } from '../../data/proposal';
export function NetworkSection() {
  return <Section id="network" index="08" label="Content network" data-id="element-163" data-mp="207mtokqamqg8">
      <div className="grid gap-5 lg:grid-cols-[1fr_0.85fr] lg:items-end lg:gap-14" data-id="element-164" data-mp="1w5i3xx2yudyv">
        <SectionTitle data-id="element-165" data-mp="2svinnhoha49b">
          From content campaign
          <br data-id="element-166" data-mp="2su7ibdfdwog3" />
          to content network.
        </SectionTitle>
        <Lead data-id="element-167" data-mp="2nvw831l6gbxc">
          You aren’t creating another campaign. You’re multiplying the distribution power of the
          campaign Solventum already has.
        </Lead>
      </div>

      <div className="mt-8 grid gap-5 lg:grid-cols-[0.8fr_1.2fr]" data-id="element-168" data-mp="2evzt5rolarfh">
        <div className="rounded-xl border border-white/10 p-6" data-id="element-169" data-mp="2evg6jxnzvev4">
          <p className="font-body text-[11px] uppercase tracking-[0.24em] text-white/40" data-id="element-170" data-mp="18gp1dhru97va">Today</p>
          <div className="mt-5 flex items-center gap-3" data-id="element-171" data-mp="13fj7hgmfzek6">
            <span className="rounded-lg border border-white/15 px-3 py-2 font-heading text-base text-white/70" data-id="element-172" data-mp="mpks730tv61j">
              Traffic
            </span>
            <ArrowRightIcon size={16} className="text-white/30" aria-hidden="true" data-id="element-173" data-mp="rndzy0hs483x" />
            <span className="rounded-lg border border-white/15 px-3 py-2 font-heading text-base text-white/70" data-id="element-174" data-mp="dnuqn4d8eqq1">
              Clinical case campaign
            </span>
          </div>
          <p className="mt-5 font-body text-sm text-white/45" data-id="element-175" data-mp="3ykwzk2qozzt">
            One door. HCPs have to find it, and then find the case that matters to them.
          </p>
        </div>

        <div className="rounded-xl border border-primary/35 bg-primary/[0.06] p-6" data-id="element-176" data-mp="3r3slp3owumuo">
          <p className="font-body text-[11px] uppercase tracking-[0.24em] text-primary" data-id="element-177" data-mp="3r1zhrw5omgqd">Proposed</p>
          <div className="mt-4 rounded-lg border border-primary/40 bg-background/60 px-4 py-2.5" data-id="element-178" data-mp="3v31gmbvosqrt">
            <p className="font-body text-[10px] uppercase tracking-[0.18em] text-primary" data-id="element-179" data-mp="3h7z4h708y56k">
              Pillar Teaser
            </p>
            <p className="mt-0.5 font-heading text-base text-white" data-id="element-180" data-mp="1ror4p69e3t5h">
              “How did they do that? Could I do that?”
            </p>
          </div>
          <div className="mt-4 grid items-center gap-3 sm:grid-cols-[1fr_auto_1fr]" data-id="element-181" data-mp="1mvo96sl1y9mn">
            <ul className="space-y-1.5" data-id="element-182" data-mp="1iwfdhi6gc1og">
              {clinicians.map(clinician => <li key={clinician.id} className="flex items-center gap-2 rounded-lg border border-white/12 bg-background/60 px-2.5 py-1.5" data-id="element-183" data-mp="1dynp2y50mxp0">
                  <img src={clinician.portrait} alt="" className="h-6 w-6 rounded-full object-cover object-top" data-id="element-184" data-mp="26m9ri32ibwaa" />
                  <span className="truncate font-body text-sm text-white/75" data-id="element-185" data-mp="1wmsnrr6tfsgy">
                    {clinician.name.replace('Dr ', '')} Teaser
                  </span>
                </li>)}
            </ul>
            <ArrowRightIcon size={18} className="mx-auto rotate-90 text-primary sm:rotate-0" aria-hidden="true" data-id="element-186" data-mp="l740sztkatg5" />
            <div className="rounded-lg border border-primary/50 bg-background/70 p-4 text-center" data-id="element-187" data-mp="g4mpvkrh0hbe">
              <p className="font-heading text-lg leading-tight text-white" data-id="element-188" data-mp="l1mudr8o9c0e">
                Filtek Clinical Cases
              </p>
              <p className="mt-2 font-body text-xs text-secondary/80" data-id="element-189" data-mp="pupgxff17l73">→ More cases</p>
            </div>
          </div>
          <p className="mt-4 font-body text-sm text-white/60" data-id="element-190" data-mp="txc9xjnfvc5v">
            Every clinician reachable from social, email, WhatsApp, congress, QR and reps.
          </p>
        </div>
      </div>

      <p className="mt-7 font-heading text-2xl text-primary lg:text-3xl" data-id="element-191" data-mp="13rbbagfourwr">
        One destination. Many reasons to enter.
      </p>
    </Section>;
}